// extracted by mini-css-extract-plugin
export default {"scoreContainer":"score-display_scoreContainer__NK6bX","icon":"score-display_icon__AgRKh","eventScoreContainer":"score-display_eventScoreContainer__Ppc5v"};